//Components
import React from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { Link } from "react-router-dom";

function NavbarCustom(props) {
  return (
    <Navbar expand="sm" variant="light" bg="fcfaf7">
      <Container>
        <Navbar.Brand>
          <Link to="/">
            <img
              src="./logos/synlabcourse_logo.png"
              height="50"
              className="d-inline-block align-top"
              alt="Synlab Logo"
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle />

        <Navbar.Collapse className="justify-content-end">
          <Nav.Link>
            <Link to="/syllabus">syllabus</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/schedule">schedule</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/tutorials">tutorials</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/readings">readings</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/assignments">assignments</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/projects">projects</Link>
          </Nav.Link>
          <Nav.Link>
            <Link to="/people">people</Link>
          </Nav.Link>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarCustom;
